import { render, staticRenderFns } from "./FormCadastro.vue?vue&type=template&id=6c36feb6"
import script from "./FormCadastro.vue?vue&type=script&lang=js"
export * from "./FormCadastro.vue?vue&type=script&lang=js"
import style0 from "./FormCadastro.vue?vue&type=style&index=0&id=6c36feb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports